export default function Divider() {
  return <hr className={`border-1 border-gray-300 mb-2`} />;
}
